package com.eladfinish.bible.contest.ui.utils

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement

/**
 * A short notice drawn by the page itself, above the app's canvas — for platform code that has no
 * access to the app's snackbar (which lives inside the composition).
 */
fun showBrowserToast(message: String, durationMillis: Int = 2500) {
    if (message.isBlank()) return
    val toast = (document.createElement("div") as HTMLDivElement).apply {
        textContent = message
        setAttribute("role", "status")
        style.cssText = """
            position: fixed; left: 50%; bottom: 72px; transform: translateX(-50%);
            max-width: 80%; padding: 10px 16px; border-radius: 8px;
            background: rgba(50, 50, 50, 0.95); color: #fff; font-size: 14px;
            text-align: center; z-index: 1000; pointer-events: none;
        """.trimIndent()
    }
    document.body?.appendChild(toast)
    window.setTimeout({ toast.remove() }, durationMillis)
}
